import { Calendar, MapPin, MoveUpRight } from 'lucide-react';
import { useEffect } from "react";
import { getCssVariable } from 'src/utils/utils';
import { Typography } from 'src/components/shared';
import Layout from '../Layout/Layout';


const AdobeSummitPartnerDay = () => {
  const primaryColor = getCssVariable('--primary-color');

  useEffect(() => {
    const script = document.createElement('script');
    script.src='https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
        if ((window as any).hbspt) {
            (window as any).hbspt.forms.create({
                portalId: '45649448',
                formId: 'c1414505-f881-4b8e-9a43-6c4db2e34704',
                target: '#hubspotForm'
            })
        }
    });
}, []);

  return (
    <Layout
      style={{
        color: primaryColor,
      }}
      hamburgerStyle={{
        backgroundColor: primaryColor,
      }}
      saleClassName={'btn-gradient-bdr'}
      headerStyle={{ position: 'relative' }}
    >
      <div className="content-left-img-component" style={{paddingBottom:"300px"}}>
        
        <div className="container-fluid custom-spacer-col">
          <div className="row align-items-start">
            {/* Left Column */}
            <div className="col-md-6 h-full flex flex-col justify-center mb-5 mb-md-0">
              <div className="d-flex flex-column align-items-start pe-m-0 max-w-450">
                
                <Typography 
                  tag="h2" 
                  style={{ display: 'inline-block', maxWidth: 'calc(14ch)', whiteSpace: 'normal' }}
                  className="mb-20"
                >
                  Gradial at Adobe Summit 2025
                </Typography>
                <Typography tag="p" className="grey-medium-dark mx-w-450 mb-20">
                Gradial is a platinum sponsor at Adobe Summit 2025 in Las Vegas! Connect with us and learn about how Gradial AI agents are transforming the enterprise content supply chain and accelerating marketing for leading brands.
                </Typography>
              </div>
              <div className="summit-event">
                <div className="summit-event-title">
                  <Typography tag="h3">
                    Partner Day Happy Hour
                  </Typography>
                  <Typography tag="p" className="grey-medium-dark mx-w-450">
                    Cocktails and conversations with partners at the frontier of AI, design, and marketing to deliver world class experiences for customers. 
                  </Typography>
                </div>
                <div className="summit-event-content">
                  <div className="summit-event-content-item">
                    <div className="summit-event-side-by-side">
                      <MapPin size={16} />
                      <Typography tag="h4">Where?</Typography>
                    </div>
                    <div className="summit-separator"></div>
                    <div className="summit-event-side-by-side">
                      <Typography tag="p" className="grey-medium-dark mx-w-450 mb-20">
                        Rosina Cocktail Club
                      </Typography>
                      <MoveUpRight size={16} />
                    </div>
                  </div>
                  <div className="summit-event-content-item">
                    <div className="summit-event-side-by-side">
                      <Calendar size={16} />
                      <Typography tag="h4">When?</Typography>
                    </div>
                    <div className="summit-separator"></div>
                    <Typography tag="p" className="grey-medium-dark mx-w-450 mb-20">
                      Monday, March 17, 2025 at 7:00 PM
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            {/* Right Column */}
            <div className="col-md-6 flex summit-event-right">
              <div className="partner-event-right-img"></div>
              <button className="btn-red-bdr" onClick={() => {
                window.open('https://www.eventbrite.com/e/gradial-partner-adobe-summit-preparty-tickets-1154788165489?aff=oddtdtcreator', '_blank');
              }}>
                Reserve your spot now
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="6"
                  height="9"
                  viewBox="0 0 6 9"
                  fill="none"
                  className="btn-red-bdr-svg"
                >
                  <path
                    d="M1 7.75L3.78571 4.5L1 1.25"
                    stroke="red"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="9"
                  viewBox="0 0 12 9"
                  fill="none"
                  className="btn-red-bdr-svg-hover"
                >
                  <path
                    d="M1 4.5h7"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M1 7.75L3.78571 4.5L1 1.25"
                    id="animated-path"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
};

export default AdobeSummitPartnerDay;
